import React, { useState } from "react";

import {
  ArrowLeft,
  TrendingUp,
  ShieldCheck,
  Wallet,
  BarChart3,
  Clock3,
  Sparkles,
} from "lucide-react";

import "../Styles/Investors.css";

import InvestorLineChart
from "../components/InvestorLineChart";

import InvestorSignupForm
from "../components/InvestorSignupForm";

import { useNavigate }
from "react-router-dom";

const Investors = () => {

  const [
    showInvestorForm,
    setShowInvestorForm,
  ] = useState(false);

  const navigate =
    useNavigate();

  return (

<div className="lucide-investors-page">

  {/* HERO */}

  <div className="lucide-investors-hero">

    <div className="lucide-investors-overlay" />

    <button
      className="lucide-back-btn"
      onClick={() =>
        navigate("/services")
      }
    >

      <ArrowLeft size={18} />

      Back to Services

    </button>

    <div className="lucide-investors-hero-content">

      <div className="lucide-investors-badge">

        <Sparkles size={16} />

        RCS Investment Platform

      </div>

      <h1>
        Invest in the Future of RCS
      </h1>

      <p>
        Grow your money through
        flexible short-term and
        long-term investment
        opportunities designed to
        fit your financial goals.
      </p>

      <div className="lucide-investor-hero-actions">

        <button
          className="lucide-primary-btn"
          onClick={() =>
            setShowInvestorForm(true)
          }
        >

          <TrendingUp size={18} />

          Become an Investor

        </button>

      </div>

    </div>

  </div>

  {/* STATS */}

  <div className="lucide-investor-stats-grid">

    <div className="lucide-investor-stat-card">

      <div className="lucide-investor-stat-icon">

        <Wallet size={26} />

      </div>

      <div>

        <h3>
          Flexible Plans
        </h3>

        <p>
          Investment periods built
          around your needs.
        </p>

      </div>

    </div>

    <div className="lucide-investor-stat-card">

      <div className="lucide-investor-stat-icon">

        <Clock3 size={26} />

      </div>

      <div>

        <h3>
          6 Weeks ROI
        </h3>

        <p>
          Earn returns quickly with
          short-term investment
          options.
        </p>

      </div>

    </div>

    <div className="lucide-investor-stat-card">

      <div className="lucide-investor-stat-icon">

        <ShieldCheck size={26} />

      </div>

      <div>

        <h3>
          Trusted Growth
        </h3>

        <p>
          Join a growing network of
          active RCS investors.
        </p>

      </div>

    </div>

  </div>

  {/* CONTENT */}

  <div className="lucide-investors-grid">

    {/* LEFT */}

    <div className="lucide-investor-card">

      <div className="lucide-card-header">

        <TrendingUp size={24} />

        <h2>
          Investment Opportunities
        </h2>

      </div>

      <p className="lucide-card-text">

        RCS recently opened its
        assets to the public,
        allowing investments from
        short-term to long-term
        opportunities.

        <br /><br />

        Investing with RCS is
        simple, flexible and
        designed to help your money
        work for you.

      </p>

      <div className="lucide-investment-types">

        <div className="lucide-investment-item">

          <span>
            6 Weeks
          </span>

          <p>
            Quick short-term ROI
          </p>

        </div>

        <div className="lucide-investment-item">

          <span>
            6 Months
          </span>

          <p>
            Medium-term investment
            growth
          </p>

        </div>

        <div className="lucide-investment-item">

          <span>
            1 Year
          </span>

          <p>
            Long-term dividend
            strategy
          </p>

        </div>

      </div>

      <button
        className="lucide-primary-btn full"
        onClick={() =>
          setShowInvestorForm(true)
        }
      >

        <TrendingUp size={18} />

        Start Investing

      </button>

    </div>

    {/* RIGHT */}

    <div className="lucide-investor-card">

      <div className="lucide-card-header">

        <BarChart3 size={24} />

        <h2>
          Investor Statistics
        </h2>

      </div>

      <div className="lucide-stats-content">

        <div className="lucide-stat-highlight">

          <h3>
            34 Active Investors
          </h3>

          <span>
            As of April 1, 2025
          </span>

        </div>

        <p className="lucide-card-text">

          Since opening investment
          opportunities in February
          2024, RCS has steadily
          expanded its investor
          network and continues to
          grow.

        </p>

        <div className="lucide-chart-wrapper">

          <InvestorLineChart />

        </div>

      </div>

    </div>

  </div>

  {/* MODAL */}

  {showInvestorForm && (

    <InvestorSignupForm
      onClose={() =>
        setShowInvestorForm(false)
      }
    />

  )}

</div>

  );
};

export default Investors;